<template>
  <v-dialog
    v-model="viewDetailStatus"
    width="1300px"
    height="auto"
    transition="dialog-top-transition"
    persistent
  >
    <v-card class="pb-3" height="auto">
      <v-toolbar class="header" dark dense>
        <v-icon>mdi-clipboard-text</v-icon>
        <span class="ml-3">Corporate Details</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="viewDetailStatusEmit((Toggle = 1))">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-tabs dense vertical align="left" class="my-tabs mt-2">
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-domain </v-icon
          >Corporate Details
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-account</v-icon
          >User Details
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-map-marker</v-icon
          >Address
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px">
            mdi-folder-account</v-icon
          >First Card Info
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-bank bank</v-icon
          >Bank Details
        </v-tab>

        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-file-document</v-icon
          >Documents Uploaded
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-file-document</v-icon
          >Card Packs Details
        </v-tab>
        <v-tab active-class="tab1">
          <v-icon class="primary--text ml-0 mr-3" style="font-size: 20px"
            >mdi-information</v-icon
          >Additional Info
        </v-tab>

        <v-tab-item>
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            class="mb-4 mt-7"
            style="margin-left: 10px; margin-right: 40px"
            shaped
          >
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Corporate Name</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="viewCorporateDetailsArray.corp_name != null"
                    >
                      {{ viewCorporateDetailsArray.corp_name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Entity Type</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="viewCorporateDetailsArray.ent_type != null"
                    >
                      {{ viewCorporateDetailsArray.ent_type }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Registration No</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="viewCorporateDetailsArray.registration_num != null"
                    >
                      {{ viewCorporateDetailsArray.registration_num }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Corporate Display ID</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="viewCorporateDetailsArray.corp_display_id != null"
                    >
                      {{ viewCorporateDetailsArray.corp_display_id }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Nature of Business</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="viewCorporateDetailsArray.nat_of_busn != null"
                    >
                      {{ viewCorporateDetailsArray.nat_of_busn }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Funding Amount</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="viewCorporateDetailsArray.funding_amount != null"
                    >
                      {{ viewCorporateDetailsArray.funding_amount }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            shaped
            style="margin-left: 10px; margin-right: 40px"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-data-table
                    :headers="userdetHeadres"
                    :items="contactpersondetails"
                    :items-per-page="5"
                    class="elevation-0 mt-0"
                  >
                    <template v-slot:[`item.sl_no`]="{ item }">
                      <span class="caption">
                        {{ contactpersondetails.indexOf(item) + 1 }}
                      </span>
                    </template>

                    <template v-slot:[`item.middle_name`]="{ item }">
                      <span class="caption" v-if="item.middle_name != null">
                        {{ item.middle_name }}
                      </span>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.last_name`]="{ item }">
                      <span class="caption" v-if="item.last_name != null">
                        {{ item.last_name }}
                      </span>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.contact_num`]="{ item }">
                      <span class="caption">{{ item.ccode }}</span>
                      <br />
                      <span class="caption">{{ item.contact_num }}</span>
                    </template>
                    <template v-slot:[`item.is_root_user`]="{ item }">
                      <v-checkbox
                        disabled
                        v-model="item.is_root_user"
                      ></v-checkbox>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- <v-row class="mt-0 pt-0">
                  <span class="subtitle-2">
                    <b class="primary--text">Name :</b>
                    {{ contactpersondetails.first_name }}
                    {{ contactpersondetails.middle_name }}
                    {{ contactpersondetails.last_name }}
                  </span>
                </v-row>
  
                <v-row class="mt-5">
                  <span class="subtitle-2">
                    <b class="primary--text">Mobile Number :</b>+60
                    {{ contactpersondetails.contact_num }}
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-5">
                  <span class="subtitle-2">
                    <b class="primary--text">E-Mail :</b>
                    {{ contactpersondetails.email_id }}
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-5">
                  <span class="subtitle-2">
                    <b class="primary--text">Desgination :</b>
                    {{ contactpersondetails.designation }}
                  </span>
                  <br />
                </v-row> -->
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col cols="12" md="6" lg="6" class="mb-6 mt-2">
              <v-card
                elevation="1"
                width="auto"
                height="auto"
                shaped
                style="margin-left: 10px; margin-right: 40px"
              >
                <span class="ml-5">Registered Address</span>
                <v-row>
                  <v-col cols="12" md="12" lg="12">
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 1 </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="registered_address.addressline1 != null"
                        >
                          {{ registered_address.addressline1 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 2 </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="registered_address.addressline2 != null"
                        >
                          {{ registered_address.addressline2 }}
                        </span>
                        <span
                          class="caption ml-2"
                          v-if="
                            registered_address.addressline2 == null ||
                            registered_address.addressline2 == ''
                          "
                        >
                          -
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">City </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="registered_address.city != null"
                        >
                          {{ registered_address.city }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">State </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="registered_address.state != null"
                        >
                          {{ registered_address.state }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Country </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="registered_address.country != null"
                        >
                          {{ registered_address.country }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Postal Code </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="registered_address.zip_code != null"
                        >
                          {{ registered_address.zip_code }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" lg="6" class="mb-6 mt-2">
              <v-card
                elevation="1"
                width="auto"
                height="auto"
                shaped
                style="margin-left: 10px; margin-right: 40px"
              >
                <span class="ml-5">Business Address</span>
                <v-row>
                  <v-col cols="12" md="12" lg="12">
                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 1</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="business_address.addressline1 != null"
                        >
                          {{ business_address.addressline1 }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3 mt-1">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Address 2</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="business_address.addressline2 != null"
                        >
                          {{ business_address.addressline2 }}
                        </span>
                        <span
                          class="caption ml-2"
                          v-if="
                            business_address.addressline2 == null ||
                            business_address.addressline2 == ''
                          "
                        >
                          -
                        </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">City </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="business_address.city != null"
                        >
                          {{ business_address.city }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">State </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="business_address.state != null"
                        >
                          {{ business_address.state }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>

                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Country </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="business_address.country != null"
                        >
                          {{ business_address.country }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Postal Code </b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="business_address.zip_code != null"
                        >
                          {{ business_address.zip_code }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            class="mb-4 mt-7"
            style="margin-left: 10px; margin-right: 40px"
            shaped
          >
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">First Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="first_cardinfo.fname != null">
                      {{ first_cardinfo.fname }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Middle Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="first_cardinfo.mname != null">
                      {{ first_cardinfo.mname }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Last Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="first_cardinfo.lname != null">
                      {{ first_cardinfo.lname }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Email-Id</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="first_cardinfo.email_id != null"
                    >
                      {{ first_cardinfo.email_id }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Mobile Number</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="first_cardinfo.mobileno != null"
                    >
                      {{ first_cardinfo.mobileno }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Desgination</b>
                    </span>
                    <br />
                    <span
                      class="caption"
                      v-if="first_cardinfo.designation != null"
                    >
                      {{ first_cardinfo.designation }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Passport/NRIC No</b>
                    </span>
                    <br />
                    <span class="caption" v-if="first_cardinfo.idnum != null">
                      {{ first_cardinfo.idnum }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            class="ml-5 mb-4 mt-5 mr-8"
            shaped
            style="margin-left: 10px; margin-right: 40px"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-data-table
                    :headers="bankheaders"
                    :items="bankitems"
                    :items-per-page="5"
                    class="elevation-0 mt-0"
                  >
                    <template v-slot:[`item.sl_no`]="{ item }">
                      <span class="caption">
                        {{ bankitems.indexOf(item) + 1 }}
                      </span>
                    </template>
                    <template v-slot:[`item.primary_acc`]="{ item }">
                      <v-checkbox
                        disabled
                        v-model="item.primary_acc"
                      ></v-checkbox>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="pl-4 mt-0 pt-0">
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            class="ml-2 mb-4 mt-5 mr-6"
            shaped
            style="margin-left: 10px; margin-right: 40px"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-data-table
                    :headers="docheaders"
                    :items="fileList"
                    :items-per-page="5"
                    class="elevation-0"
                  >
                    <template v-slot:[`item.sl_no`]="{ item }">
                      <span class="caption">
                        {{ fileList.indexOf(item) + 1 }}
                      </span>
                    </template>
                    <template v-slot:[`item.doc_url`]="{ item }">
                      <v-avatar size="36" class="mt-1 avatar" dense>
                        <img
                          v-if="
                            item.docExtn == 'jpeg' ||
                            item.docExtn == 'JPEG' ||
                            item.docExtn == 'jpg' ||
                            item.docExtn == 'JPG' ||
                            item.docExtn == 'png' ||
                            item.docExtn == 'PNG' ||
                            item.docExtn == 'webp' ||
                            item.docExtn == 'WEBP'
                          "
                          :src="item.doc_url"
                          alt="error"
                          @click="openImageInNewTab(item.doc_url)"
                        />
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'txt' || item.docExtn == 'TXT'
                          "
                          left
                          color="blue"
                          >mdi-file-document</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'pdf' || item.docExtn == 'PDF'
                          "
                          left
                          color="red"
                          >mdi-file-pdf</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'xls' ||
                            item.docExtn == 'XLS' ||
                            item.docExtn == 'xlsx' ||
                            item.docExtn == 'XLSX'
                          "
                          left
                          color="green"
                          >mdi-file-excel</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else-if="
                            item.docExtn == 'doc' ||
                            item.docExtn == 'DOC' ||
                            item.docExtn == 'docx' ||
                            item.docExtn == 'DOCX'
                          "
                          left
                          color="blue"
                          >mdi-file-word</v-icon
                        >
                        <v-icon
                          @click="openImageInNewTab(item.doc_url)"
                          v-else
                          left
                          color="blue"
                          >mdi-file-document</v-icon
                        >
                      </v-avatar>
                      <div></div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            class="ml-5 mb-4 mt-5 mr-6"
            shaped
            style="margin-left: 10px; margin-right: 40px"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-data-table
                    :headers="PackDetHeadres"
                    :items="PackDetails"
                    :items-per-page="5"
                    class="elevation-0 mt-0"
                  >
                    <template v-slot:[`item.sl_no`]="{ item }">
                      <span class="caption">
                        {{ PackDetails.indexOf(item) + 1 }}
                      </span>
                    </template>
                    <template v-slot:[`item.pack_name`]="{ item }">
                      <span class="caption" v-if="item.pack_name != null">
                        {{ item.pack_name }}
                      </span>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.pack_code`]="{ item }">
                      <span class="caption" v-if="item.pack_code != null">
                        {{ item.pack_code }}
                      </span>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.amount`]="{ item }">
                      <span class="caption" v-if="item.amount != null">
                        {{ item.amount }}
                      </span>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.quantity`]="{ item }">
                      <span class="caption" v-if="item.quantity != null">
                        {{ item.quantity }}
                      </span>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.admin_approved_date`]="{ item }">
                      <span
                        class="caption"
                        v-if="item.admin_approved_date != null"
                      >
                        {{ item.admin_approved_date }}
                      </span>
                      <span v-else>-</span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card
            elevation="1"
            width="auto"
            height="auto"
            class="mb-4 mt-9"
            style="margin-left: 10px; margin-right: 40px"
            shaped
          >
            <v-row class="mt-3">
              <v-col cols="12" md="12" lg="12">
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Referrer Name</b>
                    </span>
                    <br />
                    <span class="caption" v-if="RefDetails.name != null">
                      {{ RefDetails.name }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>

                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Referrer Email-ID</b>
                    </span>
                    <br />
                    <span class="caption" v-if="RefDetails.email_id != null">
                      {{ RefDetails.email_id }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
                <v-row class="ml-3">
                  <v-col cols="12" md="12" lg="12">
                    <span class="subtitle-2">
                      <b class="primary--text">Referrer Contact Number</b>
                    </span>
                    <br />
                    <span class="caption" v-if="RefDetails.mobile_no != null">
                      {{ RefDetails.mobile_no }}
                    </span>
                    <span class="caption ml-2" v-else> - </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>
<script>
// import moment from "moment";
export default {
  props: {
    viewDetailStatus: Boolean,
    viewCorporateDetailsArray: Object,
    contactpersondetails: Array,
    first_cardinfo: Object,
    business_address: Object,
    registered_address: Object,
    PackDetails: Array,
    fileList: Array,
    bankitems: Array,
    RefDetails: Object,
  },
  data: () => ({
    // first_cardinfo: {},
    // contactpersondetails: [],
    // PackDetails: [],
    // registered_address: "",
    // business_address: "",
    // itemsVaue: {},
    // fileList: [],
    docheaders: [
      { text: "SL NO", value: "sl_no", sortable: false },
      { text: "FILE", value: "doc_url", sortable: false },
      { text: "DOCUMENTS", value: "doc_name", sortable: false },
    ],
    keyContactheaders: [
      { text: "Name", value: "name" },
      { text: "Email", value: "email_id" },
      { text: "Mobile", value: "mobile_no" },
      { text: "Signature", value: "signature_url" },
    ],
    addressSelection: "registered_address",
    // bankitems: [],
    bankheaders: [
      { text: "Sl No", value: "sl_no", sortable: false },
      { text: "Act Type", value: "account_type", sortable: false },
      { text: "Act Name", value: "account_name", sortable: false },
      { text: "Bank Name", value: "bank_name", sortable: false },
      { text: "Act No", value: "bank_account_num", sortable: false },
      { text: "Primary Act", value: "primary_acc", sortable: false },
    ],
    userdetHeadres: [
      { text: "Sl No", value: "sl_no", sortable: false },
      { text: "First Name", value: "first_name", sortable: false },
      { text: "Midlle Name", value: "middle_name", sortable: false },
      { text: "Last Name", value: "last_name", sortable: false },
      { text: "Email-Id", value: "email_id", sortable: false },

      { text: "CONTACT NUMBER", value: "contact_num", sortable: false },
      { text: "DESIGNATION", value: "designation", sortable: false },
      { text: "ROOT USER", value: "is_root_user", sortable: false },
    ],
    PackDetHeadres: [
      { text: "Sl No", value: "sl_no", sortable: false },
      { text: "Pack Name", value: "pack_name", sortable: false },
      { text: "Pack Code", value: "pack_code", sortable: false },
      { text: "Amt", value: "amount", sortable: false },
      { text: "Qty", value: "quantity", sortable: false },
      { text: "Approved Date", value: "admin_approved_date", sortable: false },
    ],
    bindData: {},
  }),

  methods: {
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    viewDetailStatusEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
    // convertTimeStampToDate(date) {
    //   let day = date.split(" ")[0].split("-")[2];
    //   let month = date.split(" ")[0].split("-")[1];
    //   let year = date.split(" ")[0].split("-")[0];
    //   let hrs = date.split(" ")[1].split(":")[0];
    //   let mins = date.split(" ")[1].split(":")[1];
    //   let new_date = Math.floor(
    //     new Date(year, month - 1, day, hrs, mins, 0).getTime()
    //   );
    //   // console.log("newdate", new_date);
    //   let a = new Date(new_date).toLocaleDateString("en-in", {
    //     year: "numeric",
    //     month: "2-digit",
    //     day: "2-digit",
    //     hour: "2-digit",
    //     minute: "2-digit",
    //   });
    //   return a;
    // },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },
    getFileName(filename) {
      var url = filename.split("/");
      var len = url.length;
      const sample = url[len - 1];
      return sample;
    },
  },
};
</script>
<style scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
.v-data-table .avatar:hover {
  cursor: pointer;
}
.tab1 {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;
  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
.tool {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
